var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogoYunits = function SvgLogoYunits(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 333.767,
    height: 89.811,
    viewBox: "0 0 333.767 89.811",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #00ffc2;\n      }\n\n      .cls-2 {\n        fill: #007bff;\n      }\n\n      .cls-3 {\n        fill: #0032a3;\n      }\n\n      .cls-4 {\n        fill: #02225b;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9914",
    "data-name": "Group 9914",
    transform: "translate(-100.563 -113.277)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9853",
    "data-name": "Group 9853",
    transform: "translate(100.563 113.277)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_880",
    "data-name": "Group 880",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1333",
    "data-name": "Path 1333",
    className: "cls-1",
    d: "M318.02,868.46l-7.577,26.669,11.813,36.948-22.287-.085-7.373,25.95,34.935.133,25.424-89.482Z",
    transform: "translate(-266.961 -868.265)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1334",
    "data-name": "Path 1334",
    className: "cls-2",
    d: "M305.852,868.428l-34.936-.133,20.36,63.679,12.648.048L314.4,895.159Z",
    transform: "translate(-270.916 -868.295)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1335",
    "data-name": "Path 1335",
    className: "cls-3",
    d: "M309.3,891.014l-10.474,36.863,22.287.085",
    transform: "translate(-265.823 -864.149)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_882",
    "data-name": "Group 882",
    transform: "translate(321.942 4.708)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1342",
    "data-name": "Path 1342",
    className: "cls-4",
    d: "M577.412,880a5.912,5.912,0,1,0,5.912,5.912A5.911,5.911,0,0,0,577.412,880Zm3.166,9.079a4.475,4.475,0,1,1,1.313-3.166A4.456,4.456,0,0,1,580.579,889.079Z",
    transform: "translate(-571.5 -880)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1343",
    "data-name": "Path 1343",
    className: "cls-4",
    d: "M578.7,885.682a1.719,1.719,0,0,0,.3-.4,1.986,1.986,0,0,0,.188-.47,2.053,2.053,0,0,0,.066-.52,1.87,1.87,0,0,0-.143-.713,2.11,2.11,0,0,0-.4-.63,2.026,2.026,0,0,0-.6-.452,1.689,1.689,0,0,0-.758-.172h-2.621v5.817h1.343v-1.875h.876l1.114,1.875h1.516l-1.278-2.163A1.743,1.743,0,0,0,578.7,885.682Zm-.987-.811a.5.5,0,0,1-.409.226H576.07v-1.589h1.188a.572.572,0,0,1,.426.213.809.809,0,0,1,.2.573A.924.924,0,0,1,577.708,884.871Z",
    transform: "translate(-570.911 -879.575)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1928",
    "data-name": "Path 1928",
    className: "cls-4",
    d: "M25.8,38.772v15.1H15.941V38.651l-16.5-27.4H9.913L21.3,30.187,32.685,11.251h9.681ZM59.963,54.6q-9.133,0-14.218-5.054T40.662,35.119V11.251h9.864v23.5q0,11.447,9.5,11.447,4.628,0,7.063-2.77t2.436-8.677v-23.5h9.742V35.119q0,9.377-5.084,14.431T59.963,54.6Zm63.263-43.353V53.873h-8.1L93.879,28V53.873H84.136V11.251H92.3l21.189,25.878V11.251Zm5.236,0h9.864V53.873h-9.864Zm23.929,8.037H138.754V11.251H175.9v8.037H162.257V53.873h-9.864ZM190.022,54.6a34.873,34.873,0,0,1-9.773-1.37,22.92,22.92,0,0,1-7.581-3.562l3.349-7.428a22.725,22.725,0,0,0,6.515,3.227,24.472,24.472,0,0,0,7.55,1.218q4.2,0,6.211-1.248a3.771,3.771,0,0,0,2.009-3.318,3.172,3.172,0,0,0-1.187-2.527,9,9,0,0,0-3.044-1.614q-1.857-.609-5.023-1.34a69.44,69.44,0,0,1-7.976-2.314,12.959,12.959,0,0,1-5.328-3.714,10.03,10.03,0,0,1-2.222-6.82,11.863,11.863,0,0,1,2.009-6.728,13.516,13.516,0,0,1,6.058-4.78,24.722,24.722,0,0,1,9.894-1.766,32.763,32.763,0,0,1,7.976.974,23.564,23.564,0,0,1,6.82,2.8l-3.044,7.489a23.766,23.766,0,0,0-11.812-3.349q-4.14,0-6.119,1.34a4.089,4.089,0,0,0-1.979,3.532,3.453,3.453,0,0,0,2.283,3.258,35.848,35.848,0,0,0,6.972,2.1,69.437,69.437,0,0,1,7.976,2.314,13.208,13.208,0,0,1,5.328,3.653,9.8,9.8,0,0,1,2.222,6.759,11.639,11.639,0,0,1-2.04,6.667,13.7,13.7,0,0,1-6.119,4.78A24.947,24.947,0,0,1,190.022,54.6Z",
    transform: "translate(112.351 10.06)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoYunits, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo_yunits.3b968738.svg";
export { ForwardRef as ReactComponent };